import { jsx as _jsx } from "react/jsx-runtime";
import { Slot } from "@radix-ui/react-slot";
import { tv } from "tailwind-variants";
import cn from "../../utils/cn";
const typographyVariants = tv({
    base: "break-words text-gray-12 gap-1",
    variants: {
        variant: {
            // @deprecated
            display: "text-lg font-bold leading-120",
            body: "text-sm font-normal leading-135",
            "heading-1": "text-xl font-medium leading-128",
            "heading-2": "text-md font-bold leading-135",
            "description-title": "text-sm font-medium leading-135",
            "description-list-medium": "text-sm font-medium leading-135",
            "description-list-default": "text-sm font-normal leading-135",
            "button-label": "text-sm font-bold leading-120",
            "menu-default": "text-sm font-normal leading-100",
            "menu-active": "text-sm font-bold leading-100",
            "input-placeholder": "text-sm font-light leading-135",
            "input-label": "text-sm font-medium leading-135",
            "input-text": "text-sm font-normal leading-135",
            "calendar-default": "text-sm font-normal leading-100",
            "calendar-selected": "text-sm font-bold leading-100",
            "caption-bold": "text-xs font-bold leading-142",
            "caption-medium": "text-xs font-medium leading-142",
            "caption-default": "text-xs font-normal leading-142",
            "chip-label": "text-xs font-medium leading-142",
            // Heading
            "heading-5xl": "text-5xl font-semibold leading-heading-5xl",
            "heading-4xl": "text-4xl font-semibold leading-heading-4xl",
            "heading-3xl": "text-3xl font-semibold leading-heading-3xl",
            "heading-2xl": "text-2xl font-semibold leading-heading-2xl",
            "heading-xl": "text-xl font-semibold leading-heading-xl",
            "heading-lg": "text-lg font-semibold leading-lg",
            "heading-md": "text-md font-medium leading-md",
            // Text
            "text-lg": "text-md font-normal leading-lg",
            "text-lg-semibold": "text-md font-semibold leading-lg",
            "text-md": "text-sm font-normal leading-md",
            "text-md-medium": "text-sm font-medium leading-md",
            "text-md-semibold": "text-sm font-semibold leading-md",
            "text-sm": "text-xs font-normal leading-sm",
            "text-sm-medium": "text-xs font-medium leading-sm",
            // Caption
            "caption-xs": "text-xs font-normal leading-sm",
            "caption-xs-semibold": "text-xs font-semibold leading-sm",
        },
        color: {
            primary: "text-gray-12",
            default: "text-gray-12",
            secondary: "text-gray-11",
            danger: "text-danger",
            warning: "text-warning",
            white: "text-white",
            black: "text-black",
        },
    },
    defaultVariants: {
        color: "default",
        variant: "body",
    },
});
const Typography = ({ className, variant, color, asChild = false, as, ...props }) => {
    const Comp = asChild ? Slot : as || "p";
    return _jsx(Comp, { className: cn(typographyVariants({ variant, color }), className), ...props });
};
Typography.displayName = "Typography";
export default Typography;
